var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "week-days flex", class: { "is-dark": _vm.dark } },
    _vm._l(_vm.weekDays, function(weekDay, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass:
            "flex-1 text-muted lm-fs-12 flex justify-content-center align-center week-days-container"
        },
        [_vm._v("\n    " + _vm._s(weekDay) + "\n  ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }